var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '@shapeable/utils';
import { breakpoints, theme } from '@shapeable/theme';
import { Icon, ImageBubble, Toggle, useAuth, useLang } from '@shapeable/ui';
import { PersonalisedMenuReveal } from './personalised-menu-reveal';
import { PersonIcon } from '@shapeable/icons';
var cls = classNames('personalised-toggle');
export var PersonalisedToggleDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    color: ", ";\n    gap: ", ";\n  "], ["\n    display: flex;\n    align-items: center;\n    color: ", ";\n    gap: ", ";\n  "])), theme.COLOR('heading'), theme.UNIT(2))
});
var ImageStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var ToggleStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    margin-left: ", ";\n  "], ["\n    margin-left: ", ";\n  "])), theme.UNIT(2))
});
var LabelMenuStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    padding-bottom: ", ";\n  "], ["\n    padding-bottom: ", ";\n  "])), theme.UNIT(0.5))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Image: styled(ImageBubble)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), ImageStyles),
  Toggle: styled(Toggle)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), ToggleStyles),
  Menu: styled(PersonalisedMenuReveal)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), LabelMenuStyles)
};
export var PersonalisedToggle = function (props) {
  var _a, _b;
  var className = props.className;
  var _c = __read(React.useState(false), 2),
    isPersonalisedOn = _c[0],
    setIsPersonalisedOn = _c[1];
  var handleToggle = function () {
    setIsPersonalisedOn(!isPersonalisedOn);
  };
  var auth = useAuth();
  var t = useLang();
  var hasImage = (_a = auth.user) === null || _a === void 0 ? void 0 : _a.picture;
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, hasImage ? React.createElement(My.Image, {
    size: 24,
    image: {
      url: (_b = auth.user) === null || _b === void 0 ? void 0 : _b.picture
    }
  }) : React.createElement(Icon, {
    size: 24
  }, React.createElement(PersonIcon, null)), React.createElement(My.Toggle, {
    onClick: handleToggle,
    isOn: isPersonalisedOn,
    isOffColor: "text",
    isOnColor: "primary"
  }), React.createElement(My.Menu, {
    onLabel: t('Personalized Results'),
    isOn: isPersonalisedOn
  }));
};
PersonalisedToggle.cls = cls;
PersonalisedToggle.defaultProps = PersonalisedToggleDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;